import { DataSource, ReportData } from "@mcleod/components";
import { Api, LogManager, ModelRow } from "@mcleod/core";
import {
    AutogenLayoutReverseTransferSettlementWarningsAndExceptionsTable
} from "./autogen/AutogenLayoutReverseTransferSettlementWarningsAndExceptionsTable";
import { ReverseTransferSettlementStepperProps } from "./ReverseTransferSettlementStepper";

const log = LogManager.getLogger("lme.settlement.ReverseTransferSettlementWarningsAndExceptionsTable");

interface WarningAndException {
    movement_id:string,
    order_id: string,
    payee_id: string,
    payee_name: string,
    reason_type: string,
    reason: string
    triumphpay_pymt_id: string
}

export class ReverseTransferSettlementWarningsAndExceptionsTable
    extends AutogenLayoutReverseTransferSettlementWarningsAndExceptionsTable {
    public validateReversals(props: Partial<ReverseTransferSettlementStepperProps>): Promise<ReportData[]> {
        return new Promise((resolve, reject) => {
            const selectedRows = props.selectedRows;
            this.busy = true;

            Api.post("lme/settlement/reverse-transfer-from-settlement-edit", {
                order_payables: selectedRows
            }).then((response) => {
                const warningsAndExceptions = response?.data[0]?.warning_exception_data
                this.tableWarningsAndExceptions.dataSource = new DataSource();
                if (warningsAndExceptions) {
                    warningsAndExceptions.forEach(warningAndException => {
                        this.addRowToTable(warningAndException, warningAndException["response"]);
                    });
                }
                this.tableWarningsAndExceptions.applySort("movement_id", "asc", true);

                props.validMovementsCount = response?.data[0]?.valid_movements_count;

                const editList = response?.data[0]?.reverse_transfer_report_data;
                resolve(editList);
            })
            .finally(() => this.busy = false);
        });
    }

    public addWarningsAndExceptions(warningsAndExceptions) {
        this.tableWarningsAndExceptions.dataSource = new DataSource();
        warningsAndExceptions.forEach(warningAndException => {
            this.addRowToTable(warningAndException, warningAndException["response"]);
        });
    }

    private addRowToTable(row: WarningAndException, reason: string) {
        const newRowData = new ModelRow("", false);
        if (newRowData != null) {
            newRowData.set("movement_id", row.movement_id);
            newRowData.setValueAndLookupModelData("payee_id", row.payee_id, { id: row.payee_id, name: row.payee_name });
            newRowData.set("order_id", row.order_id);
            newRowData.set("reason_type", row.reason_type);
            newRowData.set("reason", row.reason);
            newRowData.set("triumphpay_id", row.triumphpay_pymt_id);
            this.tableWarningsAndExceptions.addRow(newRowData, null, { display: true, addToData: true });
        }
    }
}
